import { Button } from "~/components/ui/button";
import { TextOverflow } from "~/components/ui/text-overflow";
import type { AgentStarterPrompt } from "~/services/agents";

interface StarterPromptsProps {
  prompts: AgentStarterPrompt[];
  onPromptClick: (text: string) => void;
}

const StarterPromptButton = ({
  prompt,
  onPromptClick,
}: {
  prompt: AgentStarterPrompt;
  onPromptClick: (text: string) => void;
}) => (
  <Button
    variant="outline"
    size="sm"
    onClick={() => onPromptClick(prompt.text)}
    className="min-w-0 flex-1 justify-start rounded-full text-sm"
  >
    <TextOverflow autoTooltip delayDuration={700}>
      {prompt.text}
    </TextOverflow>
  </Button>
);

export const StarterPrompts = ({ prompts, onPromptClick }: StarterPromptsProps) => {
  const sorted = [...prompts].sort((a, b) => a.position - b.position);
  const splitIndex = sorted.length <= 3 ? sorted.length : Math.floor(sorted.length / 2);
  const topRow = sorted.slice(0, splitIndex);
  const bottomRow = sorted.slice(splitIndex);

  return (
    <div className="flex w-full max-w-2xl flex-col gap-2">
      <div className="flex gap-2">
        {topRow.map((prompt) => (
          <StarterPromptButton key={prompt.id} prompt={prompt} onPromptClick={onPromptClick} />
        ))}
      </div>
      {bottomRow.length > 0 && (
        <div className="flex gap-2">
          {bottomRow.map((prompt) => (
            <StarterPromptButton key={prompt.id} prompt={prompt} onPromptClick={onPromptClick} />
          ))}
        </div>
      )}
    </div>
  );
};
